// extracted by mini-css-extract-plugin
export var callCard = "_oh-0";
export var callMessageButton = "_oh-1";
export var helpIcon = "_oh-3";
export var helpIconContainer = "_oh-4";
export var verticalDivider = "_oh-2";